import { kebabCase } from 'lodash';

import { Heading, Grid, useTheme } from '@simplywallst/ui-core';

import { Wrapper } from './styled';
import { useHtmlReactParser } from '../../hooks';

export interface Props {
  contentHtml: string;
  title?: string;
  tag?: 'section' | 'article' | 'aside' | 'div';
  className?: string;
}

export const ContentBlock = ({
  title,
  contentHtml,
  tag = 'section',
  className,
}: Props) => {
  const theme = useTheme();
  const content = useHtmlReactParser({ html: contentHtml });
  return (
    <Wrapper
      className={className}
      as={tag}
      gap={`${theme.x2space}px`}
      data-cy-id={`narrative-${kebabCase(title)}`}
    >
      {title && (
        <Heading
          data-cy-id={`narrative-${kebabCase(title)}-heading`}
          lineClamp={2}
          typography="small"
          as="h2"
          color="whiteRGBA"
          opacity={0.5}
        >
          {title}
        </Heading>
      )}
      <Grid
        gap={`${theme.x3spacePx}px`}
        gapMd={`${theme.x2spacePx}px`}
        data-cy-id={`narrative-${kebabCase(title)}-content`}
        className="[word-break:break-word]"
      >
        {content}
      </Grid>
    </Wrapper>
  );
};
